import {useState, useCallback} from 'react';

export const useDetailsModal = () => {
  const [activeCard, setActiveCard] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openDetails = useCallback((cardinfo, labels) => {
    setActiveCard({cardinfo, labels});
    setIsOpen(true);
  }, []);

  const closeDetails = useCallback(() => {
    setIsOpen(false);
    // Keep activeCard to preserve content during closing animation
    // It will be replaced when a new card is opened
  }, []);

  return {
    activeCard,
    openDetails,
    closeDetails,
    isOpen,
  };
};
